import React from 'react';
import styled from 'styled-components';

const Holder = styled.div`
  margin: 4rem 0;
  svg {
    width: 8rem;
    height: auto;
  }
`;

function IconLoading( props ) {
  return (
    <Holder>
      <svg fill="none" height="50" viewBox="0 0 103 50" width="103" xmlns="http://www.w3.org/2000/svg">
        <rect fill="#eee" height="44" rx="22" width="93" x="10"/>
        <circle cx="76.875" cy="22.125" fill="#6e08ff" r="6.125" transform="matrix(0 1 -1 0 99 -54.75)"/>
        <circle cx="58.5" cy="22.125" fill="#fed800" r="6.125" transform="matrix(0 1 -1 0 80.625 -36.375)"/>
        <circle cx="40.125" cy="22.125" fill="#ed355f" r="6.125" transform="matrix(0 1 -1 0 62.25 -18)"/>
        <g fill="#eee">
          <circle cx="14" cy="36" r="8"/>
          <circle cx="4" cy="46" r="4"/>
        </g>
      </svg>
    </Holder>
  )
}

export default IconLoading;
